/* eslint-disable no-unused-expressions */
import DayJsUtils from '@date-io/dayjs';
import CircularProgress from '@material-ui/core/CircularProgress';
import first from 'lodash/first';
import moment from 'moment';
import React, { useState } from 'react';
import restApiClient from '../../services/restApiClient';
import ConfirmationBulkPaymentDialog from '../confirmationBulkPaymentDialog';
import SelectUnitFinance from '../selectUnitFinanceDialogControl';
import {
  ActionsContainer,
  CancelButton,
  Card,
  CardHeader,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  HeaderContainer,
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
  ProgressContainer,
  SubmitButton,
} from './styles';

function SelectBulkPaydayDialog({
  groupedExpenseId,
  onSuccess,
  onError,
  onCancel,
  ...props
}) {
  const [error, setError] = useState(false);
  const [fetchErrors, setFetchErrors] = useState(null);
  const [payday, setPayday] = useState(null);
  const [fetching, setFetching] = useState(false);
  const [unitFinanceId, setUnitFinanceId] = useState(null);
  const [openConfirmation, setOpenConfirmation] = useState(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (payday && !error && !fetchErrors) {
      const formatedDate = moment(new Date(payday)).format('YYYY-MM-DD');
      setFetching(true);
      restApiClient.expense
        .bulkPayment(groupedExpenseId, {
          payday: formatedDate,
          unitFinanceId,
        })
        .then((e) => {
          setError(false);
          setFetching(false);
          setFetchErrors(null);
          setPayday(null);
          onSuccess?.(e.data);
        })
        .catch((e) => {
          setFetching(false);
          setFetchErrors(e.response.data.errors);
        });
    } else {
      setError(true);
    }
  };

  return (
    <Container>
      <Dialog
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        disableBackdropClick
        disableEscapeKeyDown
        {...props}
      >
        <DialogContent>
          <form
            onSubmit={(e) => {
              handleSubmit(e);
            }}
          >
            <Card>
              <HeaderContainer>
                <CardHeader title="Despesa" />
              </HeaderContainer>
              <MuiPickersUtilsProvider utils={DayJsUtils}>
                <KeyboardDatePicker
                  margin="normal"
                  id="date-from"
                  label="Data do Pagamento"
                  format="DD/MM/YYYY"
                  value={payday}
                  onChange={(date) => {
                    setPayday(date);
                    setError(false);
                    setFetchErrors(null);
                  }}
                  KeyboardButtonProps={{
                    'aria-label': 'Editar data',
                  }}
                  cancelLabel="Cancelar"
                  okLabel="Selecionar"
                  invalidDateMessage="Data em formato inválido."
                  onError={(value) => setError(!!value)}
                  helperText={
                    error
                      ? 'Data em formato inválido.'
                      : fetchErrors?.payday?.length > 0
                      ? first(fetchErrors?.payday)
                      : ''
                  }
                  error={error || fetchErrors}
                  required
                />
              </MuiPickersUtilsProvider>
              <SelectUnitFinance
                label="Conta Bancária"
                size="small"
                onSuccess={(id) => {
                  setUnitFinanceId(id);
                }}
                visible
                enabled
                required
              />
            </Card>
            <DialogActions>
              <ActionsContainer>
                <CancelButton
                  onClick={() => {
                    setError(false);
                    setFetchErrors(null);
                    setPayday(null);
                    onCancel?.();
                  }}
                >
                  Cancelar
                </CancelButton>
                {fetching ? (
                  <ProgressContainer>
                    <CircularProgress size={24} />
                  </ProgressContainer>
                ) : (
                  <SubmitButton
                    onClick={() => setOpenConfirmation(true)}
                    type="button"
                    variant="contained"
                    color="primary"
                  >
                    Selecionar
                  </SubmitButton>
                )}
              </ActionsContainer>
            </DialogActions>
          </form>
        </DialogContent>
      </Dialog>

      <ConfirmationBulkPaymentDialog
        open={openConfirmation}
        onCancel={() => setOpenConfirmation(false)}
        onSuccess={(e) => {
          setOpenConfirmation(false);
          handleSubmit(e);
        }}
      />
    </Container>
  );
}

export default SelectBulkPaydayDialog;
